import { cx } from "../../lib/cx.js";
/* empty css               */
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/LinkButton/LinkButton.tsx
/**
* A text action inside content: "Show all", "View pay", "Clear search". A link (`href`)
* when it goes somewhere, a button when it does something. It meets --target-min.
*/
var LinkButton = forwardRef(function LinkButton({ children, href, as, onClick, tone = "primary", disabled = false, type = "button", className, ...rest }, ref) {
	const isLink = as !== void 0 || href !== void 0;
	const Element = as ?? (href !== void 0 ? "a" : "button");
	const elementProps = isLink ? {
		href: disabled ? void 0 : href,
		"aria-disabled": disabled || void 0,
		onClick: disabled ? (event) => event.preventDefault() : onClick
	} : {
		type,
		disabled,
		onClick
	};
	return /* @__PURE__ */ jsx(Element, {
		ref,
		...rest,
		...elementProps,
		className: cx("ds-link-button", `ds-link-button--${tone}`, className),
		children
	});
});
//#endregion
export { LinkButton };

//# sourceMappingURL=LinkButton.js.map